// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1jomh","productName":"Table_productName__L0bAR"};